import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicRecordingComment } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const fetchRecordingComments = async ({
  organisationId,
  recordingId,
}: {
  organisationId: string;
  recordingId: string;
}): Promise<PublicRecordingComment[]> => {
  const response = await axiosClient.get(
    `${organisationId}/recordings/${recordingId}/comments`,
  );
  return response.data;
};

export function fetchRecordingCommentsKey({
  organisationId,
  recordingId,
}: {
  organisationId: string;
  recordingId: string;
}) {
  return ["recordings", organisationId, recordingId];
}

export function useFetchRecordingComments(
  {
    organisationId,
    recordingId,
  }: {
    organisationId: string;
    recordingId: string;
  },
  queryOptions?: Partial<UseQueryOptions<PublicRecordingComment[], HttpError>>,
) {
  return useQuery({
    queryKey: fetchRecordingCommentsKey({ organisationId, recordingId }),
    queryFn: () =>
      fetchRecordingComments({
        organisationId,
        recordingId,
      }),
    ...queryOptions,
  });
}
